(function () {
  'use strict';

  var fgFiles = angular.module('fgFiles', []);
})();
